// frontend/src/components/Financeiro/Financeiro.js
// =============================================
// MÓDULO FINANCEIRO — Container principal com abas
// ✅ Abas: Dashboard | Despesas | Contabilidade | Crédito | Recebimentos | Exportações
// =============================================
import React, { useState } from 'react';
import { Icon } from './SharedComponents';
import FinanceiroDashboard from './FinanceiroDashboard';
import FinanceiroDespesas from './FinanceiroDespesas';
import FinanceiroContabilidade from './FinanceiroContabilidade';
import FinanceiroCredito from './FinanceiroCredito';
import FinanceiroExportacoes from './FinanceiroExportacoes';
// ✅ NOVO: Importa o componente Recebimentos do menu Vendas e Faturação
//    Ajusta o caminho conforme a localização real do ficheiro
import Recebimentos from './Recebimentos';
import './Financeiro.css';

const ABAS = [
    { id: 'dashboard', label: 'Dashboard', icone: 'analytics' },
    { id: 'despesas', label: 'Despesas', icone: 'receipt_long' },
    { id: 'contabilidade', label: 'Contabilidade', icone: 'account_balance' },
    { id: 'credito', label: 'Crédito', icone: 'group' },
    { id: 'recebimentos', label: 'Recebimentos', icone: 'payments' },   // ✅ NOVA ABA
    { id: 'exportacoes', label: 'Exportações', icone: 'download' }
];

export default function Financeiro() {
    const [abaAtiva, setAbaAtiva] = useState('dashboard');

    return (
        <div className="financeiro-wrapper">
            {/* ===== ABAS ===== */}
            <nav className="financeiro-abas">
                {ABAS.map(aba => (
                    <button
                        key={aba.id}
                        className={`fin-aba-btn ${abaAtiva === aba.id ? 'ativa' : ''}`}
                        onClick={() => setAbaAtiva(aba.id)}
                    >
                        <span className="fin-aba-icone">
                            <Icon
                                name={aba.icone}
                                size={18}
                                color={abaAtiva === aba.id ? '#fff' : 'currentColor'}
                            />
                        </span>
                        <span className="fin-aba-label">{aba.label}</span>
                    </button>
                ))}
            </nav>

            {/* ===== CONTEÚDO ===== */}
            <div className="financeiro-conteudo">
                {abaAtiva === 'dashboard' && <FinanceiroDashboard />}
                {abaAtiva === 'despesas' && <FinanceiroDespesas />}
                {abaAtiva === 'contabilidade' && <FinanceiroContabilidade />}
                {abaAtiva === 'credito' && <FinanceiroCredito />}
                {abaAtiva === 'recebimentos' && <Recebimentos />}            {/* ✅ NOVO */}
                {abaAtiva === 'exportacoes' && <FinanceiroExportacoes />}
            </div>
        </div>
    );
}